<template>
<div id="PictureForm">  
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
            <v-row>  
                <v-col cols="12" sm="6" md="4">
                 
                 
                </v-col>
                <v-col cols="12" sm="6" md="4">
                
                  
                </v-col>
                <v-col cols="12" sm="6" md="4">                
                  <!-- v-if="hasProduct && productInfo.syscom==0"                       -->
                  <v-text-field
                      v-if="hasProductCreate"
                      v-model="productInfo.stock_syscom"
                      label="*Pricelist ID"
                      readonly
                  ></v-text-field>                                                  
                  <v-text-field
                      v-if="hasCarCreate"
                      v-model="itemsInfo.fullcar_id"
                      label="*Auto ID"
                      readonly
                  ></v-text-field>
                </v-col>        
            </v-row>        
         
            <v-row
                v-if="hasCarCreate"
              >
                <v-col cols=12 sm=12 xs=12 md=12 lg=12>
                  <v-row v-for="(itemRow, k) in itemsInfo" :key="k">
                    <v-col cols=12 sm=12 xs=12 md=2 lg=2>
                      <v-btn icon @click="deleteRow(k, itemRow)">
                              <v-icon color="red">delete_outline</v-icon>
                      </v-btn> 
                    </v-col>
                    <v-col cols=12 sm=12 xs=12 md=10 lg=10>                      
                      <v-text-field                      
                              v-model="itemRow.filename"
                              label="URL Imagen"
                              :rules="[
                                // required('Url Imagen')
                              ]"          
                      />  
                    </v-col>
                  </v-row>

                </v-col>        
            </v-row>                       

    <v-row>
      <v-col cols="12" >
        <v-btn icon class="btn mr-4" @click="addNewRow" >
          <v-icon>add</v-icon>                    
        </v-btn>  
        <v-btn
                v-if="hasReset"
                color="error"
                class="mr-4"
                @click="reset"
              >
                <v-icon>cleaning_services</v-icon> Reset Form
        </v-btn> 
        <v-btn
                color="primary"
                class="mr-4"
                @click="submitForm(itemsInfo)" 
                :disabled="!valid"                
        >
              <v-icon>save</v-icon> {{buttonText}}
        </v-btn>               
        <!-- <v-btn
                            v-if="hasLoadProduct"
                            class="mr-4"
                            color="blue darken-1"                            
                            @click="getDataProduct(hasValorID)"
                          >
                             <v-icon>refresh</v-icon>
                             Cargar Datos
                          </v-btn> -->
                          <!-- {{ productInfo.id }} - ID - {{ hasValorID }} -->
                         

      </v-col>
    </v-row>
  </v-form>
</div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import validations from '@/utils/validation';
// import{ DataManager,Query, WebApiAdaptor } from "@syncfusion/ej2-data";
// import baseApi from '@/services/baseApi';
// import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: 'PictureForm',  
  components: {
  },  
  computed:{
    // 'products',
    ...mapState(['priceslist','suppliers','lines','measurements','familycategories','subfamilies'
    ,'currencies','brands','warehouses','articles']),
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    async getCatalogo(){ 
      try{        
        this.showLoading({titulo:"Accediendo información",color:"primary"})        
        // console.log("Pricelist "+sword);        
      }catch(error){       
        //code 
      }  finally{
        this.hiddenLoading()
      } 
           
    },   
    reset () {
        this.$refs.form.reset()
    },
    deleteRow(index, itemRow) {            
            var idx = this.itemsInfo.indexOf(itemRow);
            console.log(idx, index);
            if (idx==0) {
              alert('No se puede eliminar la primera fila')
            }else{
              if (idx > -1) {
                  this.itemsInfo.splice(idx, 1);
              }
            }
    },
    addNewRow() {
            
            this.itemsInfo.push({
                fullcar_id: this.hasValorID,
                filename: '',
                // posicion: this.itemsInfo.length+1,
            });
    }
  },
  props: {
    // productid: Number,
    user: Object,
    product: Object,
    submitForm:String,
    buttonText:String,
    hasValorID:Number,
    hasArticleID:Number,   
    hasCarCreate:String, 
    hasLoadProduct:String,hasProductCreate:String,hasProduct:String,hasArticle:String,
    hasPrescription:String,
    hasSalesOrder:String,hasQuote:String,hasPurchase:String,hasPurchaseAll:String,hasPricelist:String,
    hasEverybody:String,hasDescription:String,hasReset:String
  },
  data(){
     return{
        valid: false,
        ...validations,
        attribute: {sword: 'All',limit: 27},   
        itemsInfo: [{
                fullcar_id: this.hasValorID,
                filename: ''
        }],     
        productInfo:{   
          id:this.product ? this.product.id : "",
          clave_sat:this.product ? this.product.clave_sat : "",
          sku:this.product ? this.product.sku : "",
          modelo:this.product ? this.product.modelo : "",
          syscom_id:this.product ? this.product.syscom_id : "0",
          syscom:this.product ? this.product.syscom : "0",
          ctonline_id:this.product ? this.product.ctonline_id : "0",
          cva_id:this.product ? this.product.cva_id : "0",
          stock_syscom:this.product ? this.product.stock_syscom : "0",
          quote_id:this.product ? this.product.quote_id : "",
          salesorder_id:this.product ? this.product.salesorder_id : "",
          brand_id:this.product ? this.product.brand_id : "1",          
          measurement_id:this.product ? this.product.measurement_id : "1",
          famcategory_id:this.product ? this.product.famcategory_id : "",
          subfamily_id:this.product ? this.product.subfamily_id : "",
          supplier_id:this.product ? this.product.supplier_id : "",
          pricelist_id:this.product ? this.product.pricelist_id : "",
          category:this.product ? this.product.category : "otro",
          customergroup_id:this.product ? this.product.customergroup_id : "1",
          prodcategory_id:this.product ? this.product.prodcategory_id : '1',
          currency_id:this.product ? this.product.currency_id : '14',
          line_id:this.product ? this.product.line_id :  '1',
          peso:this.product ? this.product.peso :  '',
          alto:this.product ? this.product.alto :  '',
          ancho:this.product ? this.product.ancho :  '',
          largo:this.product ? this.product.largo :  '',
          metrica:this.product ? this.product.metrica : "",          
          filename:this.product ? this.product.filename : 'https://www.ionoff.com.mx/wp-content/uploads/2019/07/iOnOff_logo_100x100.png',
          canasta_basica:'0',
          type_article:this.product ? this.product.type_article : 'Productos',
          posicion:this.product ? this.product.type_article : '1',
          title:this.product ? this.product.title : "",         
          description:this.product ? this.product.description : "",         
          price:this.product ? this.product.price : "",
          cantidad:this.product ? this.product.cantidad : "",
          min_stock:this.product ? this.product.min_stock : "0",
          max_stock:this.product ? this.product.max_stock : "0",
          comision:this.product ? this.product.comision : "2.99",          
          shipping_cost:this.product ? this.product.shipping_cost : "0", 
          other_cost:this.product ? this.product.other_cost : "0", 
          num_pedimento:this.product ? this.product.num_pedimento : "0",
          status:this.product ? this.product.status : "Público", 
          notes:this.product ? this.product.notes : "", 
        },
         theader: [
        { text: 'Acción', value: 'canasta_basica' },
        // { text: 'Imagen',
        //   align: 'start',
        //   sortable: false,
        //   value: 'posicion',
        // }, 
      ],
     }
  },
  destroyed() {
    console.log("Componente eliminado");
  },
  mounted(){
    console.log("Montado Picture Form");     
    console.log("Form Auto ID " +this.hasValorID);     
    if (this.hasValorID>0) {
      this.itemsInfo.fullcar_id=this.hasValorID;
    }
  },
  created(){
    // if (this.hasValorID>0) {
    //   this.itemsInfo.fullcar_id=this.hasValorID;
    // }
  }  
}
</script>